import React, {useRef, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {Breadcrumbs, H5} from "../../../../../AbstractElements";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import SearchOptions from "../../../../CommonComponents/Search";
import WalletsTable from "../Component/WalletsTable";
import type {WalletTableRef} from "../../Types/WalletTypes";

const WalletIndex = () => {
    const [params, setParams] = useState<Record<string, unknown>>({});
    const [searchVisibility, setSearchVisibility] = useState<boolean>(false);
    const searchOptions = [{name: 'owner_name', label: 'Owner'}, {name: 'wallet_type', label: 'Wallet Type'}];
    const walletTableRef = useRef<WalletTableRef>(null);

    const getWallets = () => {
        if (walletTableRef.current) {
            walletTableRef.current.getWallets();
        }
    };

    return (
        <div>
            <Breadcrumbs mainTitle="Wallets" parent="Application" title="Wallets"/>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Wallets</H5>
                                <div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <ButtonIcon attrBtn={{
                                            onClick: getWallets
                                        }} type={'sync'} permission={'read-wallet'}/>
                                        <ButtonIcon attrBtn={{
                                            onClick: () => setSearchVisibility(!searchVisibility)
                                        }} type={'search'} permission={'read-wallet'}/>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {searchVisibility && <SearchOptions callBack={(searchParams: Record<string, unknown>) => setParams(searchParams)}
                                                                    searchOptions={searchOptions}/>}
                                <WalletsTable ref={walletTableRef} params={params}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WalletIndex;
